$('.folding__item').click(function(){
  var f = $(this);
  if (f.hasClass('folding__item_selected')){
    f.removeClass('folding__item_selected');
  } else {
    if($('.folding__item_selected').length){
      $('.folding__item_selected').removeClass('folding__item_selected');
      setTimeout(function(){
        f.addClass('folding__item_selected');
      },200);
    } else {
      $(this).addClass('folding__item_selected');
    }
  }
});
